// TODO: refactor it by removing the "Store"
import userStore from "./user";
// import loadingStore from "./loading";
import companyStore from "./company";
import companyUserStore from "./companyUser";
import companyGroupStore from "./companyGroup";
import errorStore from "./errors";
import systemStore from "./system";
import announcementStore from "./announcements";

export default {
  userStore,
  // loadingStore,
  companyStore,
  companyUserStore,
  companyGroupStore,
  errorStore,
  systemStore,
  announcementStore
};
